var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-dashboard"},[_c('BannerTitle',{attrs:{"title":_vm.bannerTitle,"description":_vm.description}}),_vm._v(" "+_vm._s(_vm.adminActionError)+" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }